import { isDefined } from '@sgme/fp';
import { toTimestamp, toTimestamps } from 'components/shared/DatePicker/utils';
import type { IntlKey } from 'locales';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import type { TranslatableContent } from 'utils/intl';
import { isTranslatableContent } from 'utils/intl';
export type PresetTranslation = IntlKey | TranslatableContent;
export const useTranslatePreset = (datePresetTranslations: readonly PresetTranslation[]) => {
  const { formatMessage } = useIntl();
  return useMemo(
    () =>
      datePresetTranslations.map(translation => {
        if (isTranslatableContent(translation)) {
          return formatMessage({ id: translation.id }, translation.values);
        }
        return formatMessage({ id: translation });
      }),
    [formatMessage, datePresetTranslations],
  );
};

export function useDisablePresets(
  allowWeekend: boolean,
  blackoutDates?: readonly string[],
  minDate?: string,
  maxDate?: string,
) {
  return useMemo<string>(() => {
    const blackoutTimestamps = toTimestamps(blackoutDates).map(time => `exact:${time}`);

    const specials = allowWeekend ? [] : ['weekends'];
    if (isDefined(minDate)) {
      specials.push('before:' + toTimestamp(minDate));
    }
    if (isDefined(maxDate)) {
      specials.push('after:' + toTimestamp(maxDate));
    }

    return [...specials, ...blackoutTimestamps].join(',');
  }, [blackoutDates, allowWeekend, minDate, maxDate]);
}
